import React from 'react';
import Player from '../../components/Paginas/Player/Player';

const PlayerPage = () => {
    return ( <Player/> );
}
 
export default PlayerPage;